import { render, staticRenderFns } from "./SelectTenant.vue?vue&type=template&id=3136d488"
import script from "./SelectTenant.vue?vue&type=script&lang=js"
export * from "./SelectTenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports